// extracted by mini-css-extract-plugin
export default {"highlight":"Connector_highlight__dmOaT","connector":"Connector_connector__NjDkw"};